import cls from "./BlogStages.module.css";

interface BlogStagesProps {
    items: { label: string; value: string }[];
}

export const BlogStages = ({ items }: BlogStagesProps) => {
    return (
        <ol className={cls.stages}>
            {items.map(({ label, value }, index) => (
                <li key={index} className={cls.stage}>
                    <span className={cls.index}>{index + 1}</span>

                    <div className={cls.card}>
                        <span className={cls.label}>{label}</span>
                        <span className={cls.value}>{value}</span>
                    </div>
                </li>
            ))}
        </ol>
    );
};
